const toBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (reader.result) {
        resolve(reader.result);
      } else {
        reject({ error: "Fail" });
      }
    };
    reader.onerror = (error) => reject(error);
  });

export default toBase64;
